import { findCountry } from "../settings/countries";

export function normalizePhone(raw: string, defaultCountryCode: string): string {
  const s = raw.trim().replace(/[\s\-().]/g, "");
  if (!s) return "";
  if (s.startsWith("+")) return s;
  if (s.startsWith("00")) return "+" + s.slice(2);

  const dial = findCountry(defaultCountryCode)?.dialCode ?? "";
  return s.startsWith("0") ? dial + s.slice(1) : dial + s;
}
